"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

require("./BreadCrumbsBase.css");

require("./BreadCrumbs.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function BreadCrumbs(_ref) {
  var items = _ref.items,
      current = _ref.current,
      rest = _objectWithoutProperties(_ref, ["items", "current"]);

  var children = rest.children;

  if (items) {
    children = items.map(function (_ref2) {
      var to = _ref2.to,
          label = _ref2.label;
      return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        key: label,
        to: to
      }, label);
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "bread-crumbs"
  }, children, /*#__PURE__*/_react.default.createElement("span", {
    className: "bread-crumbs__current"
  }, current));
}

BreadCrumbs.propTypes = {
  /** Items to be shown (can be also defined with children) */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    to: _propTypes.default.string,
    label: _propTypes.default.string
  })),

  /** Define a current position label */
  current: _propTypes.default.string,

  /** @ignore */
  children: _propTypes.default.node
};
BreadCrumbs.defaultProps = {
  items: null,
  current: null,
  children: null
};
var _default = BreadCrumbs;
exports.default = _default;